/* lua.js generated code 0.3.0 */

require("clover/logic/UserEnergy")
require("clover/logic/UserCoin")
require("clover/logic/UserCash")
require("clover/logic/userLevel/UserScore")
require("clover/logic/userLevel/UserLevel")
require("clover/logic/userLevel/UserRank")
require("clover/logic/userProp/UserPropData")
require("clover/logic/userProp/UserProp")
require("clover/logic/userDeal/UserDeal")
require("clover/logic/userDeal/UserDealData")
require("clover/logic/userProduct/UserProduct")
require("clover/logic/userShare/UserShare")
require("clover/logic/UserMark")
